import api from "./index";

interface EducationProtocolIdsListParams {
  number?: string;
  ownerId?: string;
  companyId?: string;
  courseId?: string;
  listenersIds?: Array<string>;
  listenerUserIds?: Array<string>;
  protocolCreatedAtMin?: Date;
  protocolCreatedAtMax?: Date;
  signedAt?: boolean;
  signedAtMin?: Date;
  signedAtMax?: Date;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  isArchive?: boolean;
  archivedAtMin?: Date;
  archivedAtMax?: Date;
  laborProtectionExportedAtMin?: Date;
  laborProtectionExportedAtMax?: Date;
  isLaborProtectionExported?: boolean;
  sort?: "createdAt" | "updatedAt" | "protocolCreatedAt" | "signedAt";
  order?: "ASC" | "DESC";
}

const listIds = (params: EducationProtocolIdsListParams, options?: any) => {
  return api.EducationProtocolApi.listIds(
    params.number,
    params.ownerId,
    params.companyId,
    params.courseId,
    params.listenersIds,
    params.listenerUserIds,
    params.protocolCreatedAtMin,
    params.protocolCreatedAtMax,
    params.signedAt,
    params.signedAtMin,
    params.signedAtMax,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.isArchive,
    params.archivedAtMin,
    params.archivedAtMax,
    params.laborProtectionExportedAtMin,
    params.laborProtectionExportedAtMax,
    params.isLaborProtectionExported,
    params.sort,
    params.order,
    options
  );
};

export { EducationProtocolIdsListParams, listIds };
